(function () {
  'use strict';

  angular
    .module('crewPunctualityReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewPunctualityReport', {
        url: '/crew-punctuality-report',
        views: {
          'crewPunctualityReportView': {
            templateUrl: 'crew-punctuality-report/views/crew-punctuality-report.tpl.html',
            controller: 'CrewPunctualityReportCtrl',
            controllerAs: 'crewPunctualityReport'
          }
        }
      });
  }
}());
